module.exports = __webpack_public_path__ + "media/promo/hochland/images/v1-997de4a6fd9765256872b5e63c3c644f.png";